import VehicleDymaicInfoTable from './vehicle-dymaic-info-table.vue'
export default VehicleDymaicInfoTable
